const greeting = {
  welcome: "Welcome to My Portfolio!",
  title: "Namaste 🙏 This is Atul 😎",
  subTitle: "Full Stack Developer 👨‍💻 | Freelancer 🚀 | Tech Writer ✍️ ",
  about_us:
    "https://res.cloudinary.com/dvubwtffd/image/upload/v1655647833/Projects/about_anime_ljxmbk.gif",
  home_gif:
    "https://res.cloudinary.com/dvubwtffd/image/upload/v1655647780/Projects/home_anime_nu2cud.gif",
  //   resumeLink:"https://drive.google.com/file/d/1gsPhoU4Dg-bFSlf3K-SFrKHO0XTBpS0i/view?usp=sharing",
};

const about_heading = {
  title: "About Me.",
  description:
    "Dedicated and efficient full stack developer with 8+ years experience in application layers, presentation layers, and databases.",
};

const about_me = [
  {
    id: 1,
    title: "Web Developer",
    description:
      "Developed multiple web applications as a full stack developer to process, analyze, and render data visually. Worked on query optimization for the betterment of existing sections.",
  },
  {
    id: 2,
    title: "Tech Writer",
    description: "I write technical blog for the community check out 👉",
    link: "https://devstation.hashnode.dev/",
  },
];

const skillList = [
  {
    skillName: "HTML",
    skillUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654264732/slack-images/html_rrrgvl.png",
  },
  {
    skillName: "CSS",
    skillUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654264868/slack-images/css_ayjnfs.png",
  },
  {
    skillName: "JavaScript",
    skillUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654264736/slack-images/js_awj5vo.png",
  },
  {
    skillName: "React",
    skillUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654264749/slack-images/react_twoifp.png",
  },
  {
    skillName: "NodeJS",
    skillUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654264739/slack-images/node_g5w5de.png",
  },
  {
    skillName: "React Native",
    skillUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654264749/slack-images/react_twoifp.png",
  },
  {
    skillName: "Vue",
    skillUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654264951/slack-images/vuejs_ofuqje.png",
  },
  {
    skillName: "Php",
    skillUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654264997/slack-images/php_ykflba.webp",
  },
  {
    skillName: "Laravel",
    skillUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654265126/slack-images/laravel-512_xijaqc.webp",
  },
  {
    skillName: "NuxtJs",
    skillUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654264655/slack-images/nuxt-icon-white-modified_tx6kdk.png",
  },
  {
    skillName: "MongoDB",
    skillUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654264740/slack-images/mongo_pbtvti.png",
  },
  {
    skillName: "Mysql",
    skillUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654265224/slack-images/mysql_r0hak9.png",
  },
  {
    skillName: "Aws",
    skillUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654266356/slack-images/aws1-modified_ue6an4.png",
  },
];

const socialLink = [
  {
    name: "Github",
    url: "https://github.com/iamrajput",
    link: "https://res.cloudinary.com/dvubwtffd/image/upload/v1654267816/slack-images/gh_n4bmip.png",
  },
  {
    name: "Linkedin",
    url: "https://www.linkedin.com/in/atul-kumar-singh-673357102",
    link: "https://res.cloudinary.com/dvubwtffd/image/upload/v1654267808/slack-images/li_gget6r.png",
  },
  {
    name: "Dev",
    url: "https://dev.to/atul1995",
    link: "https://d2fltix0v2e0sb.cloudfront.net/dev-badge.svg",
  },
  {
    name: "Medium",
    url: "https://devstation.hashnode.dev/",
    link: "https://res.cloudinary.com/dvubwtffd/image/upload/v1654267808/slack-images/me_rmcw6r.png",
  },
];

const projectsData = [
   {
    projectName: "Polycab Experts Program (For Electricians & Retailers)",
    started: "From 2024 to Present",
    projectDescription:
      "Earn points by scanning QR codes on eligible Polycab products. Accumulated points can be instantly transferred to your bank account. The program also includes exclusive three-tier loyalty benefits, family-focused rewards, scholarships for electricians' children, and even industry-first medical insurance for electricians and their spouses",
    imageUrl:
      "https://images.storyboard18.com/storyboard18/2026/06/polycab-new-logo-2026-06-22189c6efddc38d1b0e2a07e4d784764-1536x864.jpg",
    projectUrl: "https://polycab.com/",
  },
  {
    projectName: "Tagfi",
    started: "From 2018 to Present",
    projectDescription:
      "A real-time, hyper-local digital marketplace and networking platform that grows membership and revenue. TagFi serves over 200+ Chambers and over 100,000+ local businesses.",
    imageUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654329386/Projects/Screenshot_39_acryqx.png",
    projectUrl: "https://www.tagfi.com",
  },
  {
    projectName: "Black Diamond Sentinel ",
    started: "From 2017 to 2018",
    projectDescription:
      "BDS has developed tools for homeowners to understand the risks associated with buying a home so that they are transparent for a better decision-making process.",
    imageUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654331509/Projects/Screenshot_40_ljy3pk.png",
    projectUrl: "http://www.blackdiamondrisk.com",
  },
  {
    projectName: "Dineright",
    started: "From 2017 to 2019",
    projectDescription:
      "Booking a table has never been so easy with free and instant online restaurant reservations, Dineright is one of a kind, group dining platform that connects connoisseurs of good food to fine dining restaurants on the basis of a unique value proposition.",
    imageUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654333241/Projects/Screenshot_41_icgff1.png",
    projectUrl: "#",
  },
  // {
  // 	projectName: 'Kutchina',
  // 	started: 'From Oct 2017 to Dec 2017',
  // 	projectDescription:
  // 		"Adept Infoways has made a name for itself in the list of top service providers of Software in India. Adept Infoways is listed in Trade India's list of verified companies offering a wide array of Payroll Management Software, Fixed Asset Management Software, Compliance Management Software, etc.",
  // 	imageUrl: 'https://res.cloudinary.com/dvubwtffd/image/upload/v1654614073/Projects/Screenshot_42_ev1bwi.png',
  // 	projectUrl: 'https://www.adeptinfoways.com/'
  // }
];

const sideProject = [
  {
    projectName: "Github Profile & Job finder",
    projectDescription:
      "It is simple react app using the react hooks and many more. In this app you can search github users and github repos and the jobs.",
    imageUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654938421/Projects/side-project_um3z66.png",
    projectUrl: "https://iamfinder.netlify.app/",
  },
  {
    projectName: "RentBazzar",
    projectDescription:
      "It is a house marketplace where we can sell and rent our house. Users can contact the owner directly. Developed in React and firebase.",
    imageUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654938906/Projects/Screenshot_43_pndu2g.png",
    projectUrl: "https://rentbazaar.netlify.app/",
  },
  {
    projectName: "Code Editor",
    projectDescription:
      "This is a real-time code editor web app. Where team members can discuss the code, it`s helpful for the interview and all.",
    imageUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654939427/Projects/Screenshot_44_dvmevn.png",
    projectUrl: "https://codemantra.herokuapp.com/",
  },
  {
    projectName: "Google docs",
    projectDescription:
      "This is the kind of google docs type where you can write something and share with your network.",
    imageUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1654940480/Projects/Screenshot_45_jaru6j.png",
    projectUrl: "https://docsmantra.herokuapp.com",
  },
  {
    projectName: "Tech Talk",
    projectDescription:
      "This is for the community to connect to the network and perform realtime communication.",
    imageUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1662194759/product/code_kt5zuy.png",
    projectUrl: "https://tech-chats.netlify.app",
  },
  {
    projectName: "Portfolio Pwa App",
    projectDescription:
      "Portfolio pwa app builds with nuxt.js with all the pwa configuration like notification, offline support and all.",
    imageUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1655132038/Projects/Screenshot_48_e0edlx.png",
    projectUrl: "https://iamatulsingh.netlify.app/",
  },
  {
    projectName: "Url shortner and qr-code Generator",
    projectDescription:
      "QR Codes allow smartphone users to access website simply and quickly. This website will provide you all those features. Here users can short the very long urls as well.",
    imageUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1662194758/product/chat_ytcw04.png",
    projectUrl: "https://teeny-url.netlify.app/",
  },
  {
    projectName: "Npm Package (React Component)",
    projectDescription:
      "This is the custom react hook which you can use to call the api and it will return the data,error(if any),loading status.",
    imageUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1655132923/Projects/Screenshot_51_mbwydu.png",
    projectUrl: "https://www.npmjs.com/package/react-custom-fetch-hook",
  },
  {
    projectName: "Laravel Package",
    projectDescription:
      "Laravel package to set up contact-us mail feature where users can send mail to admin and all.",
    imageUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1655132655/Projects/Screenshot_50_rs0zle.png",
    projectUrl: "https://packagist.org/packages/atul/contact-form",
  },
  {
    projectName: "Url Shortner Service",
    projectDescription:
      "Url shortener app with rate limiter and caching for the faster response.",
    imageUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1655131390/Projects/Screenshot_47_zkkc2b.png",
    projectUrl: "https://bitly-app-shortner.herokuapp.com/api-docs/",
  },
  {
    projectName: "Quotable App",
    projectDescription:
      "Quote generator app it will generate the quotes and list it in the thread ",
    imageUrl:
      "https://res.cloudinary.com/dvubwtffd/image/upload/v1655132445/Projects/Screenshot_49_rb9dqh.png",
    projectUrl: "https://quotable-app.netlify.app/",
  },
];

export {
  greeting,
  about_heading,
  about_me,
  skillList,
  socialLink,
  projectsData,
  sideProject,
};
